export const text = {
  location: {
    noCity: 'Sem sinal',
    done: 'Monitoramento finalizado',
  },
};
